export enum CurrencySymbol {
  MZN = 'MT',
  BRL = 'R$',
}
